import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Button from 'jsx/elements/buttons/Button';

import { api } from 'api';
import Spinner from 'jsx/elements/spinner';
// import useLocale from 'jsx/locale/useLocale';

import { ApplicationTable } from './ApplicationTable';
import { useAuthContext } from 'jsx/auth/AuthProviderV2';
import { Checkbox } from './Checkbox';
export const Approved = () => {
  const { user } = useAuthContext();
  const [data, setData] = React.useState(null);
  const [checked, setChecked] = React.useState(false);

  React.useEffect(() => {
    api.getApprovedApplications(checked).then(data => setData(data));
  }, [checked]);

  if (!data) return <Spinner center size="medium" />;

  return (
    <>
      <h2 className="text-gray-dark text-28">Samþykktar umsóknir um frystingu</h2>
      <div
        className="gutter-top"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      ></div>
      <div className="gutter-top"></div>
      <div className="">
        <Checkbox
          checked={checked}
          onClick={() => setChecked(!checked)}
          label={`Sýna eingöngu umsóknir þar sem ${user.s_name} kemur fyrir`}
        />
      </div>
      <div className="gutter-top"></div>
      <ApplicationTable applications={data} approvedOnly={true} />
    </>
  );
};
